<onboarding-exit-intent variant="register" />
<div class="sign-up-container">
  <div class="container">
    <a [routerLink]="loginPage">
      <img alt="Logo" width="180" src="/assets/img/svgs/logo-redesign.svg" class="logo max-w-100" />
    </a>
    <div class="zero-text p-huge-bold mb-3">{{ 'onboarding.sign-up.headline' | transloco }}</div>
    @if (isCustomer$ | async) {
      <div class="zero-text p-base-reg mb-3">{{ 'onboarding.sign-up.already-customer.logged-in' | transloco }}</div>
      <div class="zero-text p-base-reg mb-4">{{ 'onboarding.sign-up.already-customer.text' | transloco }}</div>
      <web-design-system-button [routerLink]="loginPage">{{
        'onboarding.sign-up.already-customer.btn' | transloco
      }}</web-design-system-button>
    } @else {
      <div class="zero-text p-base-reg mb-4">{{ 'onboarding.sign-up.text' | transloco }}</div>
      <div class="zero-text p-huge-med">{{ 'onboarding.sign-up.label' | transloco }}</div>
      <web-design-system-input
        [label]="'onboarding.sign-up.placeholder' | transloco"
        [value]="email$ | async"
        (valueChange)="handleEmailChange($event)"
        [isValid]="email$ | async | email"
        [error]="(email$ | async | email) === false ? ('register.sign-up.email.error' | transloco) : null"
        class="d-block mt-4"
        data-zid="email"
      />
      @if (showPromotionInfo) {
        <div class="zero-text p-small-reg label mt-2">{{ 'register.sign-up.promotion-info' | transloco }}</div>
      }
      @if (facade.sentEmailError$ | async; as error) {
        <div data-zid="error-message-reg" class="zero-text course-red my-3">{{ error | transloco }}</div>
      }
      <div class="d-block d-md-flex justify-content-between align-items-center mt-5">
        <div class="mb-2 mb-md-0">
          {{ 'onboarding.sign-up.customer' | transloco }}
          <a data-zid="login-link" class="zero-text link" [routerLink]="loginPage">{{ 'onboarding.sign-up.login-link' | transloco }}</a>
        </div>
        <web-design-system-button data-zid="sign-up" [disabled]="(isFormValid$ | async) === false" [fullwidth]="true" (click)="submit()">
          {{ 'onboarding.sign-up.btn' | transloco }}
        </web-design-system-button>
      </div>
    }
  </div>
</div>
<onboarding-footer [hideLogout]="(isCustomer$ | async) === false" />
